<div class="checkout-container">
  <h1 class="checkout-main-title">Fill in the required information</h1>
  <h3 class="checkout-secondary-title">Payment will not be processed if failed to complete in its entirety</h3>

  <span class="legend-required">Fields with (<b>*</b>) are required</span>
  <mat-horizontal-stepper #stepper>
    <ng-template matStepperIcon="one">
      <mat-icon>person</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="two">
      <mat-icon>payment</mat-icon>
    </ng-template>
    <!--    <ng-template matStepperIcon="three">-->
    <!--      <mat-icon>attach_money</mat-icon>-->
    <!--    </ng-template>-->
    <ng-template matStepperIcon="four">
      <mat-icon>done</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="edit">
      <mat-icon class="edit-icon">edit</mat-icon>
    </ng-template>

    <mat-step state="one">
      <div class="billing-info-wrap">
        <p class="billing-label">
          Billing Information
        </p>
        <form *ngIf="billingFormGroup" [formGroup]="billingFormGroup">
          <div class="billing-inline">
            <div class="input-wrap billing-block">
              <div class="label-wrap">
                <label>First Name <span class="required-symbol">*</span></label>
              </div>
              <input appInputTrimmer formControlName="billingFirstName" placeholder="First Name" type="text"/>
              <span *ngIf="tooltipService.getState('billingFirstName')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('billingFirstName', defaultRequired, defaultExists, defaultInvalid)"
                [position]="'below'"
                [fieldName]="'First Name'">
              </app-tooltip>
            </span>
            </div>

            <div class="input-wrap billing-block">
              <div class="label-wrap">
                <label>Middle Name</label>
              </div>
              <input appInputTrimmer formControlName="billingMiddleName" placeholder="Middle Name" type="text"/>
              <span *ngIf="tooltipService.getState('billingMiddleName')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('billingMiddleName', defaultRequired, defaultExists, defaultInvalid)"
                [position]="'below'"
                [fieldName]="'Middle Name'">
              </app-tooltip>
            </span>
            </div>
          </div>
          <div class="billing-inline">
            <div class="input-wrap billing-block">
              <div class="label-wrap">
                <label>Last Name <span class="required-symbol">*</span></label>
              </div>
              <input appInputTrimmer formControlName="billingLastName" placeholder="Last Name" type="text"/>
              <span *ngIf="tooltipService.getState('billingLastName')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('billingLastName', defaultRequired, defaultExists, defaultInvalid)"
                [position]="'below'"
                [fieldName]="'Last Name'">
              </app-tooltip>
            </span>
            </div>
            <div class="input-wrap billing-block">
              <div class="label-wrap">
                <label>Address <span class="required-symbol">*</span></label>
              </div>
              <input appInputTrimmer formControlName="billingAddress" placeholder="Address"/>
              <span *ngIf="tooltipService.getState('billingAddress')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('billingAddress', defaultRequired, defaultExists, invalidAddress)"
                [position]="'below'"
                [fieldName]="'Address'">
              </app-tooltip>
            </span>
            </div>
          </div>
          <div class="billing-inline">
            <div class="input-wrap billing-block">
              <div class="label-wrap">
                <label>Address 2</label>
              </div>
              <input appInputTrimmer formControlName="billingAddress2" placeholder="Address 2"/>
            </div>
            <div class="input-wrap billing-block">
              <div class="label-wrap">
                <label>City <span class="required-symbol">*</span></label>
              </div>
              <input appInputTrimmer formControlName="billingCity" placeholder="City"/>
              <span *ngIf="tooltipService.getState('billingCity')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('billingCity', defaultRequired, defaultExists, invalidChar)"
                [position]="'below'"
                [fieldName]="'City'">
              </app-tooltip>
            </span>
            </div>
          </div>
          <div class="billing-inline">
            <div class="input-wrap input-mat-select billing-block">
              <div class="label-wrap">
                <label>State <span class="required-symbol">*</span></label>
              </div>
              <app-portal-select
                formControlName="billingState"
                [items]="stateList"
                [withFilter]="true"
                [required]="true"
                placeholder="State"
                itemId="id"
                itemName="name"
                [disabled]="billingFormGroup.get('billingState').disabled"
                (onSelectionChange)="getCounties($event)">
                <ng-template let-item #option>
                  {{item?.name}}
                </ng-template>
              </app-portal-select>
            </div>
            <div class="input-wrap billing-block">
              <div class="label-wrap">
                <label>Postal code <span class="required-symbol">*</span></label>
              </div>
              <input appInputTrimmer formControlName="billingZip" placeholder="Postal code"/>
              <span *ngIf="tooltipService.getState('billingZip')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('billingZip', defaultRequired, defaultExists, invalidZip)"
                [position]="'below'"
                [fieldName]="'Postal code'">
              </app-tooltip>
            </span>
            </div>
          </div>
          <div class="billing-inline">
            <div class="input-wrap input-mat-select billing-block">
              <div class="label-wrap">
                <label>Country <span class="required-symbol">*</span></label>
              </div>
              <app-portal-select
                formControlName="billingCountry"
                [items]="countryList"
                [withFilter]="true"
                [required]="true"
                placeholder="Country"
                itemId="id"
                itemName="name"
                [disabled]="billingFormGroup.get('billingCountry').disabled"
                (selectionChange)="getStatesById($event)">
                <ng-template let-item #option>
                  {{item?.name}}
                </ng-template>
              </app-portal-select>
            </div>
            <div class="input-wrap input-mat-select billing-block">
              <div class="label-wrap">
                <label>County <span class="required-symbol">*</span></label>
              </div>
              <app-portal-select
                formControlName="billingCounty"
                [items]="countyList"
                [withFilter]="true"
                [required]="true"
                placeholder="County"
                itemId="id"
                itemName="name"
                [disabled]="billingFormGroup.get('billingCounty').disabled">
                <ng-template let-item #option>
                  {{item?.name}}
                </ng-template>
              </app-portal-select>
            </div>
          </div>
          <div class="billing-inline">
            <div class="input-wrap billing-block">
              <div class="label-wrap">
                <label>Telephone Number <span class="required-symbol">*</span></label>
              </div>
              <app-portal-select
                formControlName="prefix"
                [items]="countryList"
                [required]="true"
                [prefix]="prefix"
                (onSelectionChange)="setPrefix($event)"
                placeholder="Select"
                itemId="id">
                <ng-template let-item #option>
                  <img alt="flag"
                       class="img-responsive img-flag-country"
                       src="/assets/flags/{{item?.code.toLowerCase()}}.png"> {{item.name | titlecase}}
                  +{{item.phoneCode}}
                </ng-template>
              </app-portal-select>
              <input appInputTrimmer class="phone-number" formControlName="billingTelephoneNumber"
                     placeholder="Telephone Number" type="tel"/>
              <span *ngIf="tooltipService.getState('billingTelephoneNumber')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('billingTelephoneNumber', defaultRequired, defaultExists, invalidChar)"
                [position]="'below'"
                [fieldName]="'Telephone Number'">
              </app-tooltip>
            </span>
            </div>
            <div class="input-wrap billing-block">
              <div class="label-wrap">
                <label>Fax Number</label>
              </div>
              <input appInputTrimmer formControlName="billingFaxNumber" placeholder="Fax Number"/>
              <span *ngIf="tooltipService.getState('billingFaxNumber')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('billingFaxNumber', defaultRequired, defaultExists, invalidChar)"
                [position]="'below'"
                [fieldName]="'Fax Number'">
              </app-tooltip>
            </span>
            </div>
          </div>
          <div class="billing-inline">
            <div class="input-wrap billing-block">
              <div class="label-wrap">
                <label>Email address <span class="required-symbol">*</span></label>
              </div>
              <input appInputTrimmer formControlName="billingEmail" placeholder="Email Address" type="email"/>
              <span *ngIf="tooltipService.getState('billingEmail')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('billingEmail', defaultRequired, defaultExists, invalidEmail)"
                [position]="'below'"
                [fieldName]="'Email Address'">
              </app-tooltip>
            </span>
            </div>
          </div>
        </form>
        <button (click)="updateBillingPartner(stepper)" class="checkout-next" color="primary" mat-flat-button>Next
        </button>
      </div>
    </mat-step>

    <mat-step state="two">
      <label class="payment-information">Payment Information</label>
      <br>
      <div class="main-div-two">
        <div class="left-div">
          <div class="payment-overview">
            <div>
              <div class="payment-overview-title">
                <p class="payment-overview-summary">
                  Past Due Invoices
                </p>
              </div>
              <form [formGroup]="form">
                <div
                  class="due-invoices"
                  *ngFor="let invoice of mandatoryInvoices; let i = index" [formGroup]="mandatoryInvoiceForms.at(i)" >
                  <mat-expansion-panel [expanded]="false">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div class="title">
                          <p class="invoice-number">{{ invoice?.number }}</p>

                          <div class="payment-total-title">
                            <p class="horizontal-dotted-line">
                              Amount Residual:<span class="dotted-line"></span>
                            </p>
                            <span class="payment-amount">
                {{ invoice.amountResidual || 0 | number: '1.2-2' }}{{ currencySymbolAfter }}
              </span>

                            <input
                              *ngIf="isAdmin"
                              appInputTrimmer
                              formControlName="amountMandatory"
                              placeholder="Amount To Pay"
                              type="number"
                              (change)="updatePayAmountMandatory($event, invoice.id, i)"
                            />
                          </div>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div>
                      <div *ngIf="invoice" class="payment-invoice-lines">
                        <div *ngFor="let line of invoice?.lines" class="payment-total">
                          <p class="horizontal-dotted-line">
                            {{ line?.name }}<span class="dotted-line"></span>
                          </p>
                          <span class="payment-amount">
              {{ line?.price * line?.quantity | number: '1.2-2' }}{{ currencySymbolAfter }}
            </span>
                        </div>
                      </div>

                      <div
                        class="payment-total"
                        *ngIf="invoice.amountTotalBeforeDiscount - invoice.amountTotal > 0"
                      >
                        <p class="horizontal-dotted-line">Discount:<span class="dotted-line"></span></p>
                        <span class="payment-amount">
            {{
                          (invoice.amountTotalBeforeDiscount - invoice.amountTotal) || 0
                            | number: '1.2-2'
                          }}{{ currencySymbolAfter }}
          </span>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </div>
              </form>
              <div class="no-past-due" *ngIf="mandatoryInvoices.length == 0">
                <span>There are currently no Past Due Invoices</span>
              </div>
            </div>
            <div>
              <div class="payment-overview-title-optional">
                <p class="payment-overview-summary">
                  Current Open Invoices
                </p>
              </div>
              <form [formGroup]="form">
                <div class="due-invoices" *ngFor="let invoice of optionalInvoices; let i = index" [formGroup]="form.get('optionalInvoices').at(i)">
                  <mat-checkbox [checked]="isInvoiceOptionChecked(invoice.id)" (change)="updateInvoicesToPay($event, invoice.id, i)">
                  </mat-checkbox>

                  <mat-expansion-panel [expanded]="false">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div class="title">
                          <p class="invoice-number">{{invoice?.number}}</p>
                          <div class="payment-total-title">
                            <p class="horizontal-dotted-line">Amount Residual:<span class="dotted-line"></span></p>
                            <span class="payment-amount">
                {{invoice.amountResidual || 0 | number:'1.2-2'}}{{currencySymbolAfter}}
              </span>
                            <input
                              *ngIf="isAdmin"
                              appInputTrimmer
                              formControlName="amountOptional"
                              placeholder="Amount To Pay"
                              type="number"
                              (change)="updatePayAmount($event, invoice.id, i)"
                              min = 1
                            />
                          </div>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div>
                      <div *ngIf="invoice" class="payment-invoice-lines">
                        <div *ngFor="let line of invoice?.lines" class="payment-total">
                          <p class="horizontal-dotted-line">{{line?.name}}<span class="dotted-line"></span></p>
                          <span class="payment-amount">
              {{line?.price * line?.quantity | number:'1.2-2'}}{{currencySymbolAfter}}
            </span>
                        </div>
                      </div>
                      <div class="payment-total" *ngIf="invoice.amountTotalBeforeDiscount - invoice.amountTotal > 0">
                        <p class="horizontal-dotted-line">Discount:<span class="dotted-line"></span></p>
                        <span class="payment-amount">
            {{(invoice.amountTotalBeforeDiscount - invoice.amountTotal) || 0 | number:'1.2-2'}}{{currencySymbolAfter}}
          </span>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </div>
              </form>
            </div>
            <div class="payment-invoices-total" *ngIf="processingFee > 0">
              <p class="horizontal-dotted-line">Processing Fee:<span class="dotted-line"></span></p>
              <span
                class="payment-amount">{{processingFee || 0 | number:'1.2-2'}}{{currencySymbolAfter}}
                </span>
            </div>
            <div class="payment-invoices-total" *ngIf="amountToPay > 0">
              <p class="horizontal-dotted-line">Total:<span class="dotted-line"></span></p>
              <span
                class="payment-amount">{{amountToPay || 0 | number:'1.2-2'}}{{currencySymbolAfter}}
                </span>
            </div>
          </div>
        </div>
        <div class="vertical-line"></div>
        <div class="right-div">
          <form *ngIf="paymentFormGroup" [formGroup]="paymentFormGroup">
            <div class="payment-method">
              <div class="payment-method-title">
                <p class="payment-method-summary">
                  Payment Method
                </p>
              </div>
            </div>
            <p *ngIf="!isBankTransfer && !isFacilityRole" class="paragraph-section">If you need any additional payment method please <a
              class="bank-transfer-method" (click)="bankTransfer()">Click here!</a></p>
            <p class="paragraph-section" *ngIf="isBankTransfer">Go back to paying through the portal <a
              class="back-btn" (click)="back()">here!</a></p>

            <div *ngIf="isBankTransfer" class="box-info">
              <i class="material-icons">info</i>
              <span class="box-info-text">Bank Transfer payments  may take 2-3 business days to be verified.</span>
            </div>

            <div class="mt-3 mb-20" *ngIf="isBankTransfer">
              <div class="show-more">
                <div class="container" [class.show]="firstshow">
                  <mat-panel-title>
                    <p class="second-title">Step 1 - Make your payment with your bank </p>
                  </mat-panel-title>
                  <div class="p-3">
                    <p><b>ACH instructions:</b></p>
                    <div class="ml-4">
                      <ul>
                        <li><p>Contact your bank and provide the amount listed on your invoice to be debited<br>
                          from your account and credited to our account.</p>
                        </li>
                        <li><p>Provide our bank information below:</p></li>
                      </ul>
                      <div class="mt-2">
                        <p>Company name: QUAD A</p>
                        <p>QUAD A bank's routing number: 272483633</p>
                        <p>QUAD A bank account number: 1110060303488</p>
                      </div>
                    </div>
                  </div>
                  <div class="p-3">
                    <p><b>Wire Transfer instructions:</b></p>
                    <div class="ml-4">
                      <ul>
                        <li><p>Note: International incoming wires must be sent using the correspondent bank, BMO Harris. No foreign currency will be accepted (Only wires in US funds may be processed). Advia Credit Union is not responsible for any origination or exchange rate adjustments that may lower the intended amount of the wire.</p>
                        </li>
                        <li><p>Contact your bank and provide the amount listed on your invoice plus an additional
                          $25.00
                          bank wire <br>
                          transfer fee to be debited from your account and credited to our account.</p>
                        </li>
                        <li><p> Provide our bank information below, as appropriate:</p></li>
                      </ul>
                      <div class="ml-2 mt-3">
                        <p style="font-weight: bold">International Wire Tranfer Instructions:</p>
                        <div class="ml-2">
                          <div class="mt-2">
                            <p>BMO Harris</p>
                            <p>111W. Monroe St.</p>
                            <p>Chicago, IL 60603</p>
                          </div>
                          <div class="mt-2">
                            <p> SWIFT code: HATRUS44</p>
                            <p> ABA: 071000288</p>
                          </div>
<!--                          <div class="mt-2">-->
<!--                            <p>Beneficiary:</p>-->
<!--                            <p>071925680 - NorthSide Community Bank</p>-->
<!--                            <p>5103 Washington St</p>-->
<!--                            <p>Gurnee, IL 60031</p>-->
<!--                          </div>-->
                          <div class="mt-2">
                            <p>For Further Credit:</p>
                            <p>ADVIA Credit Union</p>
                            <p>6400 West Main St</p>
                            <p>Kalamazoo, Michigan 49009</p>
                            <p>Account # 470-279-04</p>
                            <p>Final Credit: QUAD A</p>
                            <p>Account # 110060303488</p>
                          </div>
                        </div>
                      </div>
                      <div class="ml-2 mt-3">
                        <p style="font-weight: bold">Domestic Wire Tranfer Instructions:</p>
                        <div class="ml-2">
                          <div class="mt-2">
                            <p>ADVIA Credit Union</p>
                            <p>ABA 272483633</p>
                            <p>6400 West Main St</p>
                            <p>GKalamazoo, Michigan 49009</p>
                          </div>
                          <div class="mt-2">
                            <p>Beneficiary: QUAD A</p>
                            <p>Account Number: 110060303488</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <mat-icon (click)="firstshow = !firstshow">{{ first-show ? 'expand_less' : 'expand_more' }}</mat-icon>
              </div>

              <div class="show-more">
                <div class="container" [class.show]="show">
                  <mat-panel-title>
                    <p class="second-title mb-3">Step 2 - Record your payment in the QUAD A portal</p>
                  </mat-panel-title>
                  <p>Once your bank processes the transaction, your bank will give you a confirmation number.</p>
                  <div class="ml-4">
                    <ul>
                      <li><p>Please keep this number for your records</p></li>
                      <li><p>Enter the above confirmation number in the "Reference" field below</p></li>
                      <li><p>You may add any notes you wish to the “Description” field below</p></li>
                    </ul>
                  </div>
                  <div class="mt-2 mb-3">
                    <p>Your funds will be received by QUAD A within 2-3 business days of processing by your bank.</p>
                    <p>Once the funds are received, QUAD A will verify the confirmation number you provided and
                      validate
                      your
                      payment.</p>
                    <p>Once validated, your invoice will be marked as “Paid”.</p>
                    <p>You will receive an email notification confirming your payment</p>
                  </div>
                </div>
                <mat-icon (click)="show = !show">{{ show ? 'expand_less' : 'expand_more' }}</mat-icon>
              </div>
            </div>

            <div class="input-wrap input-icon">
              <label for="amount">Amount <span class="required-symbol">*</span></label>
              <input appInputTrimmer class="bank-reference" formControlName="amount"
                     id="amount" type="number" placeholder="Amount" readonly>
              <i>$</i>
              <span *ngIf="tooltipService.getState('amount')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('amount', defaultRequired, defaultExists, defaultInvalid)"
                [position]="'below'"
                [fieldName]="'Amount'">
              </app-tooltip>
            </span>
            </div>
            <div [hidden]="isBankTransfer || isStripePayment">
              <!-- List of cards -->
              <div class="ucx-accordion">
                <div class="ucx-accordion-header">
                  <div class="add-new">
                    <a (click)="onAddNewCard()" *appPermissions="permissions.canUserCreateAndUpdateCard"
                       class="cmp-button cmp-button--outline mt-20">Add New</a>
                  </div>
                </div>
                <div *ngIf="cards" [ngClass]="{'ucx-accordion-body': true, 'card-empty': (!cards || !cards.length) }">
                  <ul *ngIf="cards">
                    <li *ngFor="let card of cards; let i = index"
                        [ngClass]="{'stripe-card': true, 'card-active': card.id === defaultCard }">
                      <app-stripe-card-item (stripeItemChanged)="onStripeItemChanged($event)"
                                            [cardOptions]="{ cardIndex: i }"
                                            [card]="card" [defaultCard]="defaultCard"
                                            [permissions]="permissions"></app-stripe-card-item>
                    </li>
                  </ul>
                  <div *ngIf="(!cards || !cards.length)" class="card_empty">
                    <img class="no-card-img" src="assets/images/no-credit-card.svg">
                    <p>You have not added your Credit Card info yet. <br> Press “Add new” to add your Credit Card.</p>
                  </div>
                </div>
              </div>
            </div>
            <div [hidden]="!isBankTransfer">
              <p class="bank-information">Bank Information</p>
              <div class="input-wrap">
                <label for="ref">Confirmation number/ Transaction number/ Reference <span
                  class="required-symbol">*</span></label>
                <input appInputTrimmer class="bank-reference input-wrap" formControlName="ref" id="ref" type="text"
                       placeholder="Confirmation number/ Transaction number/ Reference" [maxLength]="100">
                <span *ngIf="tooltipService.getState('ref')">
            <app-tooltip
              [errorMessages]="tooltipService.inputValidation('ref', defaultRequired, defaultExists, invalidChar)"
              [position]="'below'"
              [fieldName]="'Bank Information'">
            </app-tooltip>
          </span>
              </div>
            </div>
            <div [hidden]="!isStripePayment" class="input-wrap">
              <p class="bank-information">Stripe Payment</p>
              <div>

                <ng-container *ngIf="elementsOptions?.clientSecret as clientSecret">
                  <ngx-stripe-payment [clientSecret]="clientSecret" [appearance]="appearance" (change)="onChange($event)">
                  </ngx-stripe-payment>
                </ng-container>
                <div class="checkbox-for-savings">
                  <mat-checkbox *ngIf="isStaff" (change)="setFuturePayment($event)">Save for future payment!
                  </mat-checkbox>
                  <span *ngIf="isStaff" class="material-icons info-icon"
                        matTooltip="The payment method will be saved only after you make a payment with this method."
                        matTooltipPosition="above">info
                  </span>
                </div>
                <div class="action-button-footer">
                  <div class="save-stripe-card">
                    <cmp-button *ngIf="showBtnExistingPaymentMethod" [class]="'cancel cmp-button--outline mr-20'"
                                text="Existing Payment Method" (click)="closeAddNewCard()"></cmp-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="input-wrap description-total">
              <label for="description">Description</label>
              <textarea class="payment-description" formControlName="description" id="description" placeholder=""
                        rows="2" (keyup)="onKeyUp($event)"></textarea>
              <div>
                {{numberOfCharacters}} / {{maxNumberOfCharacters}}
              </div>
              <span *ngIf="tooltipService.getState('description')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('description', defaultRequired, defaultExists, invalidDesc)"
                [position]="'below'"
                [fieldName]="'Description'">
              </app-tooltip>
            </span>
            </div>
            <div *ngIf="isStaff" class="accept-terms">
              <mat-checkbox (change)="termsAcceptedChange($event)">
                I have the requisite authority to act on behalf of this facility,<br> I have reviewed and accept the <a href="https://www.quada.org/terms-conditions" target="_blank">QUAD A Terms and Conditions.</a>
              </mat-checkbox>
            </div>
            </form>
        </div>
      </div>
      <div class="payment-buttons">
        <cmp-button class="primary mr-20 custom-btn" text="Back" (click)="goBack(stepper)"></cmp-button>
        <app-spinner-button [btnColor]="'primary w-100'"
                            (spinClick)="completePayment($event, stepper)" text="Pay"></app-spinner-button>
      </div>
    </mat-step>
    <mat-step state="three">
      <div class="payment-success-modal">
        <div class="payment-status">
          <img class="payment-success" src="assets/images/payment-modal-success.svg">
        </div>
        <div class="payment-message">
          <span class="payment-message-main">Thank you!</span>
          <span class="payment-message-secondary">{{response }}</span>
        </div>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</div>

